import React, { FC } from "react";
import { Link, useHistory } from "react-router-dom";
import { Input, Button, Popover, Avatar, Menu, Dropdown } from "antd";
import {
  UserOutlined,
  WifiOutlined,
  DeploymentUnitOutlined,
  AimOutlined,
} from "@ant-design/icons";
// import request from '../../../utils/request';
import { useSelector } from "react-redux";
import { selectLogStatus } from "../../../store/userSlice";
import getRootPath from "../../../utils";

import { Card, Col, Row } from "antd";

import "./index.css";
const { Search } = Input;
const button_type = {};
interface categoriesProp {
  title: string;
  children: category[];
}

interface category {
  name: string;
  path: string;
}

// 解决方案库：目录配置
const solutionsOptions: categoriesProp[] = [
  {
    title: "控制类业务",
    children: [
      { name: "配电自动化", path: "/powerAutomation" },
      { name: "5G配电综合业务", path: "/PowerDistributionSynthesis" },
      { name: "5G配网分布式差动保护", path: "/netWorkHapoopProtect" },
      { name: "态势感知", path: "/typePerceive" },
      { name: "分布式光伏", path: "/Photovoltaic" },
      { name: "5G智能电力切片网关", path: "/PowerSlicingGateway" },
    ],
  },
  {
    title: "采集类业务",
    children: [
      { name: "用电信息采集", path: "/powerCollection" },
      { name: "车联网充电站/桩系统", path: "/chargeSystem" },
      { name: "分布式电源监控系统", path: "/monitorSystem" },
      { name: "5G虚拟量测平台", path: "/VirtualMeasurement" },
    ],
  },
  {
    title: "移动应用类/交互类业务",
    children: [
      { name: "机器人、无人机巡检", path: "/robotInspection" },
      { name: "MEC VR/MR", path: "/MECVRMR" },
      { name: "5G+高清视频监控", path: "/videoInspection" },
      { name: "500kV 5G智慧电力隧道", path: "/Tunnel" },
      { name: "5G+卫星应急体系", path: "/Satellite" },
    ],
  },
];

// 知识库：目录配置
const knowledgesOptions: categoriesProp[] = [
  {
    title: "组网部署",
    children: [
      { name: "5G SA和NSA部署模式知识", path: "/saNsa" },
      { name: "5G MEC", path: "/mec" },
      { name: "5G LAN技术", path: "/lan" },
      { name: "5G TSN技术", path: "/tsn" },
      { name: "5G 网络切片", path: "/networkSlice" },
    ],
  },
  {
    title: "5G三大应用场景",
    children: [
      { name: "eMBB", path: "/eMBB" },
      { name: "uRLLC", path: "/uRLLC" },
      { name: "mMTC", path: "/mMTC" },
    ],
  },
  {
    title: "5G工业互联网融合",
    children: [
      { name: "MEC园区", path: "/mecPark" },
      { name: "工厂内网改造全连接工厂", path: "/factory" },
    ],
  },
  /* {
    title: '5G 核心网部署模式及演进策略', children: [
      { name: 'EPC 升级为5G NSA', path: '/evolutionStrategyOne' },
      { name: '引入5G 核心网', path: '/evolutionStrategyTwo' },
      { name: '5G 核心网与EPC 融合演进，实现统一核心网', path: '/evolutionStrategyThree' },
    ],
  }, */
];

const platOptions: categoriesProp[] = [
  {
    title: "5G工业互联网接入规划仿真系统",
    children: [{ name: "功能介绍", path: "/simulationPlatform" }],
  },
];

const teachOptions: categoriesProp[] = [
  {
    title: "培训中心",
    children: [
      { name: "培训中心", path: "/trainingCenter" },
      { name: "培训中心", path: "http://px.5gwlhtg.com" },
      { name: "更多课程", path: "/buptict" },
    ],
  },
];

// 根据目录配置生成 jsx 元素
const getCategories = (options: categoriesProp[]) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", width: 800, height: 450 }}>
      {options.map(
        ({ title, children }: { title: string; children: category[] }) => {
          return (
            <div>
              <div className="catalogue-wrapper">
                <div className="catalogue-title">{title}</div>
                {children.map(
                  ({ name, path }: { name: string; path: string }) => (
                    <div className="catalogue-line">
                      <Link to={path} className="catalogue-text">
                        {name}
                      </Link>
                    </div>
                  )
                )}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

const solutionsCategories = getCategories(solutionsOptions);

const knowledgesCategories = getCategories(knowledgesOptions);

const platCategories = getCategories(platOptions);

const teachCategories = getCategories(teachOptions);

const CustomHeader: FC = () => {
  const isLogin = useSelector(selectLogStatus); //获取用户当前是否登录的状态
  const history = useHistory();

  const menu = (
    <Menu>
      <Menu.Item onClick={() => history.push("/userInfo")}>个人信息</Menu.Item>
      <Menu.Item
        onClick={() => {
          window.location.href = `/cas/logout?service=${encodeURIComponent(
            getRootPath()
          )}`;
        }}
      >
        注销登录
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div
        style={{
          backgroundColor: "#222",
          color: "#fff",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 60,
          zIndex: 999,
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "space-between",
            height: 60,
            borderBottom: "1px solid rgba(255,255,255,.1)",
            paddingLeft: 23,
          }}
        >
          {/* <div style={{ fontSize: 22, width: '50%' }}><Link to="/" style={{ color: '#fff', fontSize: '2rem' }}>5G网络化推广公共服务平台</Link></div> */}

          <div
            style={{
              display: "flex",
              alignContent: "center",
              height: 60,
              width: "50%",
            }}
          >
            <Button type="text" style={{ color: "#fff" }}>
              <a href="/" style={{ color: "#fff", fontSize: "2rem" }}>
                5G网络化推广公共服务平台
              </a>
            </Button>
          </div>

          <div
            style={{
              marginRight: 50,
              display: "flex",
              alignContent: "center",
              height: 60,
              marginTop: 15,
            }}
          >
            {/* <Search
              style={{width: 200}}
              placeholder="搜索"
            />
            {
              !isLogin ? (
                <Button
                  style={{marginLeft: 20, marginRight: 20}}
                >
                  登录
                </Button>
              ) : (
                <Dropdown overlay={menu} placement="bottomCenter">
                  <Avatar style={{marginLeft: 20, marginRight: 20, marginTop: -5}} size="large" icon={<UserOutlined />} />
                </Dropdown>
              )
            } */}
            <Button style={{ marginLeft: 20, marginRight: 20 }}>
              {/* 登录 */}
              <a href="http://px.5gwlhtg.com/p/index/login">登录</a>
            </Button>
            <Button type="primary">
              {/* 注册 */}
              <a href="http://px.5gwlhtg.com/p/reg/reg">注册</a>
            </Button>
          </div>
        </div>
        {/* display: 'flex' */}
      </div>
      <div
        style={{
          backgroundColor: "#222",
          alignContent: "center",
          width: "100%",
          paddingLeft: 25,
          paddingTop: 60,
        }}
      >
        {/* <Button type="text" style={{color: '#fff'}}>
              <Link to='/new' style={{color: '#fff'}}>最新进展</Link>
            </Button> */}
        <Popover
          placement="bottomLeft"
          mouseLeaveDelay={0.2}
          content={solutionsCategories}
          trigger="hover"
          arrowPointAtCenter
        >
          <Button
            className="button_type"
            type="link"
            style={{ color: "#fff", fontSize: "17px" }}
          >
            5G与工业互联网融合应用解决方案库
          </Button>
        </Popover>
        <Popover
          placement="bottomLeft"
          mouseLeaveDelay={0.2}
          content={knowledgesCategories}
          trigger="hover"
          arrowPointAtCenter
        >
          <Button
            className="button_type"
            type="link"
            style={{ color: "#fff", fontSize: "17px" }}
          >
            5G网络建设模式知识库
          </Button>
        </Popover>
        <Popover
          placement="bottom"
          mouseLeaveDelay={0.2}
          content={platCategories}
          trigger="hover"
          arrowPointAtCenter
        >
          <Button
            className="button_type"
            type="link"
            style={{ color: "#fff", fontSize: "17px" }}
          >
            5G工业互联网接入规划仿真系统
          </Button>
        </Popover>

        {/* 5G培训中心跳转链接 */}
        <Button className="button_type" type="text" style={{ color: "#fff" }}>
          <a
            href="http://www.buptict.cn"
            target="_blank"
            style={{ color: "#fff", fontSize: "17px" }}
            rel="noreferrer"
          >
            5G培训中心与更多课程
          </a>
        </Button>
      </div>
    </div>
  );
};

export default CustomHeader;
